var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 377.26,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 134.74
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 134.74
  })), /*#__PURE__*/React.createElement("rect", {
    y: 134.74,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 242.53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB955"
    },
    d: "M344.824,221.594l-85.529,34.912c-0.034-0.087-0.074-0.165-0.114-0.248l82.601-41.367  c-3.266-6.519-7.233-12.625-11.837-18.192l-71.213,58.893c-0.072-0.089-0.112-0.202-0.191-0.284l65.28-65.345  c-4.658-4.658-9.805-8.821-15.337-12.445l-50.542,77.363c-0.114-0.077-0.218-0.167-0.341-0.23L298.895,172  c-6.632-3.323-13.701-5.893-21.101-7.613l-20.986,90.002c-0.267-0.064-0.521-0.163-0.808-0.163s-0.541,0.099-0.808,0.163  l-20.986-90.002c-7.4,1.72-14.469,4.29-21.101,7.613l41.294,82.651c-0.124,0.064-0.227,0.154-0.341,0.23l-50.542-77.363  c-5.532,3.625-10.679,7.787-15.337,12.445l65.28,65.345c-0.08,0.082-0.12,0.194-0.191,0.284l-71.213-58.893  c-4.603,5.567-8.571,11.673-11.837,18.192l82.601,41.367c-0.04,0.083-0.081,0.161-0.114,0.248l-85.529-34.912  c-2.578,6.323-4.495,12.982-5.678,19.895l91.056,15.765c-0.012,0.079-0.04,0.152-0.047,0.233l-91.912-9.575  c-0.331,3.243-0.503,6.533-0.503,9.864c0,5.759,0.536,11.39,1.509,16.87L256,264.88l94.399,9.765  c0.973-5.48,1.509-11.11,1.509-16.87c0-3.331-0.171-6.621-0.503-9.864l-91.912,9.575c-0.007-0.081-0.035-0.154-0.047-0.233  l91.056-15.765C349.32,234.576,347.403,227.917,344.824,221.594z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M163.306,282.429c0.658,2.481,1.417,4.919,2.265,7.317h180.858c0.848-2.397,1.607-4.836,2.265-7.317   c-8.861-1.145-9.961-6.892-20.754-6.892c-11.984,0-11.984,7.104-23.967,7.104s-11.984-7.104-23.968-7.104   c-11.987,0-11.987,7.104-23.974,7.104c-11.98,0-11.98-7.104-23.961-7.104c-11.991,0-11.991,7.104-23.982,7.104   c-11.999,0-11.999-7.104-23.998-7.104C173.282,275.537,172.182,281.285,163.306,282.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M325.115,300.402c-11.535-0.002-11.537-7.104-23.075-7.104c-11.54,0-11.54,7.104-23.08,7.104   c-11.54,0-11.54-7.104-23.08-7.104c-11.543,0-11.543,7.104-23.086,7.104c-11.537,0-11.537-7.104-23.074-7.104   c-11.547,0-11.547,7.104-23.094,7.104c-10.245,0-11.423-5.574-19.607-6.841c1.954,4.854,4.27,9.523,6.957,13.945H325.11h0.009   h12.905c2.693-4.433,5.014-9.114,6.971-13.98C336.566,294.711,335.466,300.4,325.115,300.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M334.287,313.145c-2.233-1.17-4.878-2.086-9.011-2.086c-11.54,0-11.54,7.104-23.08,7.104   s-11.54-7.104-23.08-7.104c-11.543,0-11.543,7.104-23.086,7.104c-11.537,0-11.537-7.104-23.074-7.104   c-11.547,0-11.547,7.104-23.094,7.104c-11.555,0-11.555-7.104-23.109-7.104c-4.147,0-6.798,0.92-9.036,2.093   c3.056,4.312,6.444,8.371,10.154,12.116h136.257C327.84,321.52,331.23,317.46,334.287,313.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M315.1,333.282c-3.487-2.021-6.291-4.463-13.061-4.463c-11.54,0-11.54,7.104-23.08,7.104   c-11.54,0-11.54-7.104-23.08-7.104c-11.543,0-11.543,7.104-23.086,7.104c-11.537,0-11.537-7.104-23.074-7.104   c-6.681,0-9.501,2.376-12.924,4.38c4.754,3.737,9.867,7.032,15.284,9.828h87.842C305.298,340.252,310.375,336.985,315.1,333.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M232.957,346.58c-3.782,0-6.317,0.767-8.433,1.792c9.863,3.427,20.447,5.312,31.477,5.312h0.018   C244.494,353.679,244.489,346.58,232.957,346.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M256.086,353.682c11.014-0.01,21.583-1.897,31.432-5.324c-2.109-1.018-4.638-1.778-8.401-1.778   C267.593,346.58,267.57,353.658,256.086,353.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M268.616,245.633l-30.392-8.784c-1.705-0.493-2.886-2.031-2.908-3.806   c-0.14-11.254-0.629-50.882-0.629-56.967c0-7.104,7.104-17.761,21.313-17.761h11.203c1.061,0,1.38,1.443,0.405,1.861   c-5.131,2.2-11.608,6.783-11.608,15.9c0,10.825,10.308,15.464,15.218,17.06c1.518,0.493,2.543,1.887,2.543,3.483v45.144   C273.761,244.445,271.191,246.377,268.616,245.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M241.809,285.389c1.114-0.675,2.435,0.452,1.934,1.654c-2.975,7.142-10.265,20.463-23.265,20.463   c-17.761,0-21.313-14.209-21.313-24.865v-75.346c0-1.547,1.254-2.801,2.801-2.801h5.054c1.547,0,2.801,1.254,2.801,2.801v71.794   C209.822,288.693,230.02,292.527,241.809,285.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M268.7,285.389c-1.114-0.675-2.435,0.452-1.934,1.654c2.975,7.142,10.265,20.463,23.265,20.463   c17.761,0,21.313-14.209,21.313-24.865v-75.346c0-1.547-1.254-2.801-2.801-2.801h-5.054c-1.547,0-2.801,1.254-2.801,2.801v71.794   C300.687,288.693,280.49,292.527,268.7,285.389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M294.056,273.761h-76.111c-0.562,0-1.018-0.456-1.018-1.018v-1.516c0-0.562,0.456-1.018,1.018-1.018   h76.111c0.562,0,1.018,0.456,1.018,1.018v1.516C295.074,273.305,294.618,273.761,294.056,273.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M224.474,260.352l3.846-5.129c0.59-0.784,0.43-1.897-0.356-2.487   c-0.784-0.586-1.897-0.423-2.485,0.357l-1.497,1.996v-1.378c0-0.982-0.794-1.776-1.776-1.776s-1.776,0.794-1.776,1.776v1.249   l-1.4-1.866c-0.588-0.784-1.701-0.947-2.485-0.357c-0.786,0.59-0.945,1.703-0.356,2.487l3.846,5.129l-3.846,5.129   c-0.59,0.784-0.43,1.897,0.356,2.487c0.319,0.239,0.692,0.354,1.063,0.354c0.541,0,1.074-0.246,1.422-0.711l3.224-4.299   l3.224,4.299c0.349,0.465,0.881,0.711,1.422,0.711c0.371,0,0.744-0.114,1.063-0.354c0.786-0.59,0.945-1.703,0.356-2.487   L224.474,260.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M257.627,260.352l3.846-5.129c0.59-0.784,0.43-1.897-0.356-2.487   c-0.784-0.586-1.897-0.423-2.485,0.357l-1.497,1.996v-1.378c0-0.982-0.794-1.776-1.776-1.776s-1.776,0.794-1.776,1.776v1.249   l-1.4-1.866c-0.588-0.784-1.702-0.947-2.485-0.357c-0.786,0.59-0.945,1.703-0.356,2.487l3.846,5.129l-3.846,5.129   c-0.59,0.784-0.43,1.897,0.356,2.487c0.319,0.239,0.692,0.354,1.063,0.354c0.541,0,1.074-0.246,1.422-0.711l3.224-4.299   l3.224,4.299c0.349,0.465,0.881,0.711,1.422,0.711c0.371,0,0.744-0.114,1.063-0.354c0.786-0.59,0.945-1.703,0.356-2.487   L257.627,260.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M241.05,260.352l3.846-5.129c0.59-0.784,0.43-1.897-0.356-2.487   c-0.784-0.586-1.897-0.423-2.485,0.357l-1.497,1.996v-1.378c0-0.982-0.794-1.776-1.776-1.776s-1.776,0.794-1.776,1.776v1.249   l-1.4-1.866c-0.588-0.784-1.701-0.947-2.485-0.357c-0.786,0.59-0.945,1.703-0.356,2.487l3.846,5.129l-3.846,5.129   c-0.59,0.784-0.43,1.897,0.356,2.487c0.319,0.239,0.692,0.354,1.063,0.354c0.541,0,1.074-0.246,1.422-0.711l3.224-4.299   l3.224,4.299c0.349,0.465,0.881,0.711,1.422,0.711c0.371,0,0.744-0.114,1.063-0.354c0.786-0.59,0.945-1.703,0.356-2.487   L241.05,260.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M274.204,260.352l3.846-5.129c0.59-0.784,0.43-1.897-0.356-2.487   c-0.784-0.586-1.897-0.423-2.485,0.357l-1.497,1.996v-1.378c0-0.982-0.794-1.776-1.776-1.776s-1.776,0.794-1.776,1.776v1.249   l-1.4-1.866c-0.588-0.784-1.702-0.947-2.485-0.357c-0.786,0.59-0.945,1.703-0.356,2.487l3.846,5.129l-3.846,5.129   c-0.59,0.784-0.43,1.897,0.356,2.487c0.319,0.239,0.692,0.354,1.063,0.354c0.541,0,1.074-0.246,1.422-0.711l3.224-4.299   l3.224,4.299c0.349,0.465,0.881,0.711,1.422,0.711c0.371,0,0.744-0.114,1.063-0.354c0.786-0.59,0.945-1.703,0.356-2.487   L274.204,260.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M290.781,260.352l3.846-5.129c0.59-0.784,0.43-1.897-0.356-2.487   c-0.784-0.586-1.897-0.423-2.485,0.357l-1.497,1.996v-1.378c0-0.982-0.794-1.776-1.776-1.776s-1.776,0.794-1.776,1.776v1.249   l-1.4-1.866c-0.588-0.784-1.702-0.947-2.485-0.357c-0.786,0.59-0.945,1.703-0.356,2.487l3.846,5.129l-3.846,5.129   c-0.59,0.784-0.43,1.897,0.356,2.487c0.319,0.239,0.692,0.354,1.063,0.354c0.541,0,1.074-0.246,1.422-0.711l3.224-4.299   l3.224,4.299c0.349,0.465,0.881,0.711,1.422,0.711c0.371,0,0.744-0.114,1.063-0.354c0.786-0.59,0.945-1.703,0.356-2.487   L290.781,260.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M221.195,284.731c2.627,1.149,18.059,1.313,21.999-2.791s3.119-5.91,3.119-5.91l-18.716,0.164   L221.195,284.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA4650"
    },
    d: "M290.055,284.731c-2.627,1.149-18.059,1.313-21.999-2.791c-3.94-4.104-3.119-5.91-3.119-5.91   l18.716,0.164L290.055,284.731z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrench);
export default __webpack_public_path__ + "static/media/french.4a5f848efcd0e49a005e1f12058dc950.svg";
export { ForwardRef as ReactComponent };